import React from 'react'
import {
  Menu,
  Item,
  useContextMenu,
  animation
} from 'react-contexify'
import { map } from 'lodash'

const RightClickMenu = ({ trigger, menuItems, mainObjectId, objectType, menuStyle }) => {
  const menuID = `contextmenu-${objectType}-${mainObjectId}`
  const { show } = useContextMenu({
    id: menuID
  })

  return (
    <div style={menuStyle}>
      <div onContextMenu={show}>
        {trigger}
      </div>

      <Menu id={menuID} animation={animation.fade}>
        {map(menuItems, item => (
          <Item
            onClick={() => item.handleClick(mainObjectId)}
            className={`${objectType === 'ticket-priority' ? 'react-contexify__item__content__center' : ''}`}
          >
            {item.label}
          </Item>
        ))}
      </Menu>
    </div>
  )
}

export default RightClickMenu
